import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";

// Los 313 concellos de Galicia (INE, nombre oficial, provincia, centro y si tiene logo). Se piden una vez por sesión.
let cache = null;
let pending = null;
export const loadConcellos = () => {
  if (cache) return Promise.resolve(cache);
  if (!pending) pending = api.get("/concellos").then((r) => { cache = r.data; return cache; }).finally(() => { pending = null; });
  return pending;
};
export const refreshConcellos = () => { cache = null; return loadConcellos(); };

export const useConcellos = () => {
  const [list, setList] = useState(cache || []);
  useEffect(() => {
    let ok = true;
    loadConcellos().then((d) => ok && setList(d)).catch(() => {});
    return () => { ok = false; };
  }, []);
  return list;
};
export const useConcello = (ine) => useConcellos().find((c) => c.ine === ine) || null;

export const PROVINCIAS = ["A Coruña", "Lugo", "Ourense", "Pontevedra"];
export const logoUrl = (ine, v) => `${API}/concellos/${ine}/logo${v ? `?v=${v}` : ""}`;
// población del evento a partir del concello (centro del mapa por defecto)
export const townOf = (c) => (c ? { name: c.nombre, province: `${c.provincia}, Galicia`, lat: c.lat, lng: c.lng } : null);

// Logo del concello en documentos: si no tiene, no se muestra nada
export const ConcelloLogo = ({ ine, className = "h-16 w-auto", v }) => {
  const [ok, setOk] = useState(true);
  useEffect(() => setOk(true), [ine, v]);
  if (!ine || !ok) return null;
  return <img src={logoUrl(ine, v)} alt="Logo del concello" className={`object-contain ${className}`} onError={() => setOk(false)} data-testid="concello-logo" />;
};

// Desplegable con los concellos agrupados por provincia
export const ConcelloSelect = ({ value, onChange, list, testid, allowAll, className = "" }) => (
  <select value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid}
    className={`h-9 rounded-md border border-slate-300 px-2 text-sm bg-white focus:outline-none focus:border-sky-500 ${className}`}>
    {allowAll ? <option value="">Todos los concellos</option> : !value && <option value="">Elija el concello…</option>}
    {PROVINCIAS.map((p) => (
      <optgroup key={p} label={p}>
        {list.filter((c) => c.provincia === p).sort((a, b) => a.nombre.localeCompare(b.nombre, "gl")).map((c) => <option key={c.ine} value={c.ine}>{c.nombre}</option>)}
      </optgroup>
    ))}
  </select>
);
